import React from 'react';

import SSOSignOutCallbackPage from 'web-shared/modules/auth/pages/CallbackPages/SSOSignOutCallbackPage';
import ZitadelCallbackPage from 'web-shared/modules/auth/pages/CallbackPages/ZitadelCallbackPage';
import { createProtectedAppRouter } from 'web-shared/utils/routing';
import { createReduxStore } from 'web-shared/reducers/utils';
import ApplicationPack from 'web-shared/modules/ApplicationPack';

import App from './App';
import reducer from './reducer';

const router = createProtectedAppRouter({
  App,
  routes: [
    { path: 'sign-in/zitadel', element: <ZitadelCallbackPage /> },
    { path: 'sign-out', element: <SSOSignOutCallbackPage /> },
  ],
  mixedTheme: false,
});

const store = createReduxStore(reducer);

const RootPack = () => <ApplicationPack store={store} router={router} mixedTheme={false} />;

export default RootPack;
